module.exports = __webpack_public_path__ + "img/404.a08bdfcf.gif";